// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_o9-5";
export var filledCircle = "_o9-4";
export var historyEntry = "_o9-3";
export var messageSideLeft = "_o9-1";
export var messageSideRight = "_o9-2";
export var orderTrackingCarouselWrapper = "_o9-6";
export var orderTrackingInfoContainer = "_o9-0";